var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextValignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 27.5H28.8182C30.0208 27.5 31 28.061 31 28.75C31 29.439 30.0208 30 28.8182 30H9.18182C7.97924 30 7 29.439 7 28.75C7 28.061 7.97924 27.5 9.18182 27.5Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 20.9778C23.2222 20.6 22.5556 20.6 22.1111 20.9778L20.1111 22.6778V7.94444C20.1111 7.37778 19.6667 7 19 7C18.3333 7 17.8889 7.37778 17.8889 7.94444V22.6778L15.8889 20.9778C15.4444 20.6 14.7778 20.6 14.3333 20.9778C13.8889 21.3556 13.8889 21.9222 14.3333 22.3L18.2222 25.6056C18.4444 25.7944 18.7778 25.8889 19 25.8889C19.2222 25.8889 19.5556 25.7944 19.7778 25.6056L23.6667 22.3C24.1111 21.9222 24.1111 21.2611 23.6667 20.9778Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextValignBottom);
export default __webpack_public_path__ + "static/media/text_valign_bottom.bb11d5780f1573a2e71a2e16c4b8a13f.svg";
export { ForwardRef as ReactComponent };